import React from "react";
import './heading.css';

export default function Heading () {
    return (
        <div>
            <h2>The Cowboy's Ghost</h2>
        </div>
    )
};